import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Check, Edit } from '../../../components/Icon';
import { Modal, ModalControls } from '../../../components/Modal';
import { CompanySelection } from './CompanySelection';
import { CompanyLabel } from './CompanyLabel';

const STATE = {
  active: false,
  company: null,
};

/* eslint-disable react/prefer-stateless-function */
class CompanySelectionModalButtonComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    return (
      <>
        {this.state.active ? this.renderModal() : null}
        <Button small onClick={this.setStateFn({ active: true })}>
          {this.props.label ?? <Edit />}
        </Button>
      </>
    );
  }

  renderModal() {
    return (
      <Modal onClose={this.reset.bind(this)} title={this.lbl('company.search.placeholder')}>
        <VBox center vCenter>
          <CompanySelection onSelect={company => this.setState({ company })} />
        </VBox>
        {this.state.company ? (
          <HBox vCenter left>
            <Check />
            <CompanyLabel company={this.state.company} />
          </HBox>
        ) : null}
        <ModalControls>
          <Button onClick={() => this.props.onChange?.(this.state.company?.id)} disabled={!this.state.company}>
            {this.lbl('save')}
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }
}

CompanySelectionModalButtonComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const CompanySelectionModalButton = compose(
  withConnect,
  withRouter,
  injectIntl,
)(CompanySelectionModalButtonComp);
